module.exports = __webpack_public_path__ + "img/136ne.f619f57a.svg";